// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Create/Universe.css
// module id = 701
// module chunks = 0